import { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import AppLayout from '@/components/layouts/AppLayout'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'
import type { Release } from '@/types'

interface Props {
  vendor: { id: number; name: string; slug: string }
  app_entry: { id: number; name: string; slug: string }
  release: Release
}

interface PageProps {
  errors?: Record<string, string[]>
}

export default function ReleaseEdit({ vendor, app_entry, release }: Props) {
  const { props } = usePage<PageProps>()
  const [form, setForm] = useState({
    version: release.version,
    changelog: release.changelog || '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    router.patch(
      `/vendors/${vendor.slug}/app_entries/${app_entry.slug}/releases/${release.id}`,
      { release: form },
    )
  }

  const errors = props.errors || {}

  return (
    <AppLayout>
      <Paper sx={{ p: 4, maxWidth: 700, mx: 'auto' }}>
        <Typography variant="h5" gutterBottom>
          Edit Release v{release.version} — {app_entry.name}
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            label="Version"
            required
            value={form.version}
            onChange={(e) => setForm({ ...form, version: e.target.value })}
            error={!!errors.version}
            helperText={errors.version?.join(', ') || 'Semver format: major.minor.patch'}
          />
          <TextField
            label="Changelog"
            multiline
            rows={10}
            value={form.changelog}
            onChange={(e) => setForm({ ...form, changelog: e.target.value })}
            error={!!errors.changelog}
            helperText={errors.changelog?.join(', ') || 'Markdown supported'}
          />
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button
              onClick={() =>
                router.visit(
                  `/vendors/${vendor.slug}/app_entries/${app_entry.slug}/releases`,
                )
              }
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained">
              Update Release
            </Button>
          </Box>
        </Box>
      </Paper>
    </AppLayout>
  )
}
